module.exports = __webpack_public_path__ + "img/Ya_Chao_(Rachel)_Zhao.8a72b6d5.png";